export default "__VITE_ASSET__CeM0vHJM__"